import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCommandParams, getFilters, getFormDesign, getObjectState, getRecData } from "../../../redux/selectors";
import { changeToBuffer, setChange, setFilter, setObjectState } from "../../../redux/features/ui/uiSlice";
import { calculate } from "../../../services/calculate";
import { TiDeleteOutline } from "react-icons/ti";

const S1Time = ({ element, tabID, screenState, currentLine }) => {
  const table = element.name.split(".")[0];
  const key = element.name.split(".")[1];

  const commandParams = useSelector((state) => getCommandParams(state, tabID));

  const dispatch = useDispatch();
  const objectState = useSelector((state) => getObjectState(state, tabID));
  const filters = useSelector((state) => getFilters(state, tabID));
  const formDesign = useSelector((state) => getFormDesign(state, tabID));
  const model = screenState == "form" && formDesign && formDesign.model[table].fields.filter((el) => el.name == key)[0];
  const data = useSelector((state) => getRecData(state, tabID));
  const tableIndex = formDesign?.model?.[table]?.relationship == "OneToOne" ? 0 : currentLine?.index ?? 0;

  const dateRef = React.useRef(null);

  const [clear, showClear] = React.useState(false);
  const [isFocused, setIsFocused] = React.useState(false);
  const [value, setValue] = React.useState("");

  const handleCalculate = async (table, key, value) => {
    dispatch(setChange({ tabID, table, tableIndex, key, value }));
    model?.updates && (await calculate(tabID, objectState));
  };

  const handleClear = () => {
    setValue("");
    if (screenState == "dialog") {
      dispatch(setFilter({ tabID, table, key, value: "" }));
    } else {
      if (objectState == "view") {
        dispatch(changeToBuffer({ tabID }));
        dispatch(setObjectState({ tabID, value: "edit" }));
      }
      handleCalculate(table, key, "");
    }
  };

  React.useEffect(() => {
    if (screenState == "dialog") {
      setValue(element.value);
      dispatch(setFilter({ tabID, table, key, value: element.value }));
    }
  }, [screenState]);

  React.useEffect(() => {
    if (screenState == "form") {
      if (data?.[table]?.[tableIndex]?.[key] && data?.[table]?.[tableIndex]?.[key] != "") {
        setValue(timeConverterForView(data?.[table]?.[tableIndex]?.[key]));
      } else {
        setValue("");
      }
    }
  }, [data?.[table]?.[tableIndex]?.[key]]);

  const handleChange = (value) => {
    if (screenState == "dialog") {
      setValue(value);
      dispatch(setFilter({ tabID, table, key, value: timeConverterForData(value) }));
    } else if (screenState == "form") {
      if (objectState == "view") {
        dispatch(changeToBuffer({ tabID }));
        dispatch(setObjectState({ tabID, value: "edit" }));
      }
      handleCalculate(table, key, timeConverterForData(value));
    }
  };

  return (
    <div
      className="s1time w-100"
      style={{ flex: `${element.flex * 100}%`, overflow: "hidden", visibility: element.visible ? "visible" : "hidden" }}
    >
      <div className="inputGroup">
        <label className="text-truncate" htmlFor={element.index}>
          {`${element.caption}:`}
        </label>
        <div
          className={`input-with-buttons${isFocused ? " underline-focus" : ""}${
            element.required && value == "" ? " required" : ""
          }`}
          style={{ display: "flex", flexGrow: 1, gap: "0.5rem" }}
          role="button"
        >
          <div className="d-flex w-100" onMouseEnter={() => showClear(true)} onMouseLeave={() => showClear(false)}>
            <input
              ref={dateRef}
              type="time"
              name={element.name}
              className={`w-100${value != "" ? " date-input-has-value" : ""}${
                element.readOnly || (screenState == "form" && commandParams.readonly) ? " disabled" : ""
              }`}
              disabled={element.readOnly || (screenState == "form" && commandParams.readonly)}
              readOnly={element.readOnly}
              value={value}
              onChange={(e) =>
                !(element.readOnly || (screenState == "form" && commandParams.readonly)) && handleChange(e.target.value)
              }
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              onClick={() => {
                if (!(element.readOnly || (screenState == "form" && commandParams.readonly))) {
                  dateRef.current.showPicker();
                  dateRef.current.click();
                  dateRef.current.focus();
                }
              }}
            />
            {value != "" && clear && !(element.readOnly || (screenState == "form" && commandParams.readonly)) && (
              <div onClick={handleClear}>
                <TiDeleteOutline size="30px" role="button" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default S1Time;

const timeConverterForView = (value) => {
  if (value != "") {
    var d = new Date(value);
    return d.getHours().padLeft() + ":" + d.getMinutes().padLeft();
  } else {
    return value;
  }
};

const timeConverterForData = (value) => {
  if (value != "") {
    return "1899-12-30 " + value;
  } else {
    return value;
  }
};
